import { masterApiService } from 'api/config'
import { Setting } from 'types/setting'
import { useQuery } from '@tanstack/react-query'
import { getSettingsOverride } from 'utils/query-params'

export const SETTINGS_QUERY_KEY = 'setting'

export const fetchSetting = async (): Promise<Setting | undefined> => {
  const [remote] = await masterApiService.getList<Setting>('settings')
  console.debug('[fetchSetting] response', {
    hasRemote: !!remote,
    isPortalHidden: remote?.isPortalHidden,
    portalAuthMode: remote?.portal?.authMode,
    keys: remote ? Object.keys(remote) : null,
  })
  if (!remote) return remote

  const override = getSettingsOverride()
  if (override) {
    console.debug('[fetchSetting] applying override', override)
  }
  return override ? ({ ...remote, ...override } as Setting) : remote
}

export const useGetSetting = () => {
  const { data, ...result } = useQuery({
    queryKey: [SETTINGS_QUERY_KEY],
    queryFn: fetchSetting,
    staleTime: 5 * 60 * 1000,
    gcTime: Infinity,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })

  const loading = result.isLoading || result.isFetching || result.isRefetching

  return {
    setting: data,
    colors: {
      primary: data?.primaryColor,
      secondary: data?.secondaryColor,
    },
    title: data?.portal?.title ?? 'Mimir',
    description: data?.portal?.description ?? 'Your smart assistance',
    operatorSettings: {
      numberOfQuestionsBeforeAskTicketOpen: data?.operatorSettings?.numberOfQuestionsBeforeAskTicketOpen ?? 2,
      welcomeMessage: data?.operatorSettings?.welcomeMessage ?? '',
      offlineMessage: data?.operatorSettings?.offlineMessage ?? '',
    },
    // Number of bot responses before showing ticket suggestion (0 = disabled)
    numberOfQuestionsBeforeAskTicketOpen: data?.operatorSettings?.numberOfQuestionsBeforeAskTicketOpen ?? 2,
    loading,
    ...result,
  }
}
